import { TrackerStub } from './TrackerStub';
import { of } from 'rxjs';
import { Option } from '../classes';

export class ReplyServiceStub {
  setCheck() {}
  isChecked() {}
  toggle() {}
  save() {}
  getCheck(option: any) {
    return null;
  }
  tracker = new TrackerStub();
  onChange = of(null);
  getLatest() {
    return of(null);
  }
  watch() {
    return of(null);
  }
}
